import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
// import { LoaderComponent } from "../../../Common/LoaderComponent";
import ReactDataTable from "../../../Common/ReactDataTable";

const List = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(true);

  // const fetchData = () => {
  //   Http.get("/receipe").then((res) => {
  //     setReceiveData(res.data);
  //   });
  // };
  const fetchData = async () => {
    setLoading(true); // Start loading

    try {
      const res = await Http.get(`/receipe`);
      setReceiveData(res.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false); // Stop loading regardless of the outcome
    }
  };
  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const deleteData = (id, deleteApiUrl, showMsg) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.delete("/" + deleteApiUrl + "/" + id).then((res) => {
          setReceiveData(res.data);
          Swal.fire("Deleted!", showMsg + " has been deleted.", "success");
        });
      }
    });
  };

  const toggleStatus = (id, currentStatus) => {
    const newStatus = currentStatus ? "inactive" : "active"; // Determine the new status
    Swal.fire({
      title: currentStatus ? "Deactivate Recipe?" : "Activate Recipe?",
      text: "Are you sure you want to change the status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: currentStatus ? "Yes, deactivate it!" : "Yes, activate it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await Http.post(`/recipe-status-toggle/${id}`, { id, status: newStatus }); // Send the new status
          if (res.data.success) {
            await fetchData(); // Reload the data from backend after toggling
            Swal.fire("Success!", "Recipe status has been updated.", "success");
          }
        } catch (error) {
          console.error("Error toggling status:", error);
          Swal.fire("Error!", "There was an error updating the status.", "error");
        }
      }
    });
  };

  const actionTemplate = (item, deleteData) => {
    const isActive = item.status === "active";
    const nextStatus = isActive ? "Inactive" : "Active";
    const btnClass = isActive ? "secondary" : "success";

    return (
      <td className="text-xs">
        <Link
          to={{ pathname: "/view-receipe/" + item.id }}
          className="btn btn-info btn-sm ms-1" title="View receipe"
        >
          <i className="fa fa-list" aria-hidden="true"></i> 
        </Link>
        <button
          className={`btn btn-${btnClass} ms-2 btn btn-sm ms-1`}
          onClick={() => toggleStatus(item.id, item.status === "active")}
        >
          {nextStatus}
        </button>
      </td>
    );
  };

  const cols = [
    { field: "receipt_no", header: "Recipe No." },
    { field: "product.name", header: "Finished Goods" },
    { field: "product.code", header: "Finished Goods Codes" },
    { field: "batch_size", header: "Batch Size" },
    { field: "department_art.name", header: "Department" },
    {
      field:(item) => {return item.status.toUpperCase()},
      header: "Status"
    },
  ];

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Recipes</h5>
            <Link to="/create-receipe" className="btn btn-primary" title="Create Recipe">
              <i className="fa fa-plus-square mg-r-6"></i>New
            </Link>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              {/* <div className="row">
                <div className="table-responsive p-0 pb-2">
                  <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0 datatable">
                    <thead>
                      <tr>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          S/N
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Finished Goods
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Batch Size
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Yield %
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Action
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {receiveData.map((item, index) => (
                        <tr key={item.id}>
                          <td className="text-xs">{index + 1}</td>
                          <td className="text-xs">
                            {item.product
                              ? item.product.name + " - " + item.product.code
                              : ""}
                          </td>
                          <td className="text-xs">{item.batch_size}</td>
                          <td className="text-xs">{item.yield}</td>
                          <td className="text-xs">
                            <Link
                              to={{ pathname: "/edit-receipe/" + item.id }}
                              className="btn btn-primary btn-sm"
                            >
                              <i
                                className="fa fa-pencil"
                                aria-hidden="true"
                              ></i>
                            </Link>
                            <button
                              className="btn btn-danger btn-sm ms-1"
                              onClick={() =>
                                deleteData(item.id, "receipe", "receipe")
                              }
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div> */}
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
                actionTemplate={actionTemplate}
                deleteData={deleteData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
// const actionTemplate = (item, deleteData) => {
//   return (
//     <td className="text-xs">
//       <Link
//         to={{ pathname: "/view-receipe/" + item.id }}
//         className="btn btn-info btn-sm ms-1" title="View receipe"
//       >
//         <i className="fa fa-list" aria-hidden="true"></i> 
//       </Link>
//       <button
//           className={`btn btn-${item.active ? "success" : "secondary"}`}
//           onClick={() => toggleStatus(item.id, item.active)}
//         >
//           {item.active ? "Active" : "Inactive"}
//         </button>
//       {/* <Link
//         to={{ pathname: "/edit-receipe/" + item.id }}
//         className="btn btn-primary btn-sm mx-1"
//       >
//         <i className="fa fa-pencil" aria-hidden="true"></i>
//       </Link>
//       <button
//         className="btn btn-danger btn-sm ms-1"
//         onClick={() => deleteData(item.id, "receipe", "receipe")}
//       >
//         <i className="fa fa-trash"></i>
//       </button> */}
//     </td>
//   );
// };
export default List;
